
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class OverlayAccountDialog extends SiteEntityDialog<OverlayAccountRow, any> {
        protected getFormKey() { return OverlayAccountForm.formKey; }
        protected getIdProperty() { return OverlayAccountRow.idProperty; }
        protected getLocalTextPrefix() { return OverlayAccountRow.localTextPrefix; }
        protected getNameProperty() { return OverlayAccountRow.nameProperty; }
        protected getService() { return OverlayAccountService.baseUrl; }

        protected form = new OverlayAccountForm(this.idPrefix);

    }
}